import type { ColumnProperties } from '../../../components/StripColumnsContainer/Column'
import type { MediaPaddingLayerCSSVars } from '@wix/thunderbolt-becky-types'

const getMediaPadding = (compProps: ColumnProperties) => ({
	top: compProps.mediaBackgroundPadding?.top ?? 0,
	bottom: compProps.mediaBackgroundPadding?.bottom ?? 0,
})

export const shouldPadMedia = ({
	isMobileView,
	compProps,
}: {
	isMobileView: boolean
	compProps: ColumnProperties
}): boolean => {
	const mediaPadding = getMediaPadding(compProps)

	return isMobileView && (mediaPadding.top > 0 || mediaPadding.bottom > 0)
}

export const getMediaPaddingLayerCSSVars = ({
	isMobileView,
	compProps,
}: {
	isMobileView: boolean
	compProps: ColumnProperties
}): MediaPaddingLayerCSSVars | undefined => {
	if (!shouldPadMedia({ isMobileView, compProps })) {
		return
	}

	const mediaPadding = getMediaPadding(compProps)
	return {
		'--media-padding-top': `${mediaPadding.top}px`,
		'--media-padding-bottom': `${mediaPadding.bottom}px`,
		'--media-padding-height': `calc(100% - ${mediaPadding.top}px - ${mediaPadding.bottom}px)`,
	}
}
